import useWindowDimensions from './useWindowDimensions.hook';

const useIsMobile = (width = 900) => {
  const { innerWidth } = useWindowDimensions();
  return innerWidth < width;
};

export default useIsMobile;